// ink-component
import React from 'react';
import styled from 'styled-components';
import getGlobalProps from '../../helpers/constants/global-props';
import { headerTokens } from '../../tokens/components/Header/tokens';

export interface AppShellProps extends React.HTMLAttributes<HTMLDivElement> {}

export type AppShellContentWrapperProps = {
  isSideNavClosed?: boolean;
};

// Scaffolding that mirrows styles in .app-shell in src/assets/sass/5-global/_global.scss
const AppShellWrapper = styled.div<React.HTMLAttributes<HTMLDivElement>>`
  min-height: 100vh;
  display: block;
`;

const AppShellHeaderWrapper = styled.div<React.HTMLAttributes<HTMLDivElement>>`
  background-color: white;
  position: sticky;
  top: 0;
  z-index: 999;
`;

const AppShellBodyWrapper = styled.div`
  display: grid;
  grid-template-areas: 'sidenav content';
  grid-template-columns: max-content minmax(0, 1fr);
`;

const AppShellSideNavWrapper = styled.div`
  grid-area: sidenav;
  height: calc(100vh - ${headerTokens.SizeBaseDefault});
  position: sticky;
  top: ${headerTokens.SizeBaseDefault};
  overflow: auto;

  @media screen and (max-width: 1199px) {
    overflow: visible;
    z-index: 998;
  }
`;

const AppShellContentWrapper = styled.div<AppShellContentWrapperProps>`
  display: flex;
  flex-direction: column;
  grid-area: content;
`;

const AppShellDevFooter = styled.div`
  position: sticky;
  display: flex;
  justify-content: space-between;
  align-items: center;
  bottom: 0;
`;

const globalProps = getGlobalProps({});

const AppShell = (props: AppShellProps) => {
  return <AppShellWrapper {...props} {...globalProps} />;
};

AppShell.Header = AppShellHeaderWrapper;
AppShell.Body = AppShellBodyWrapper;
AppShell.SideNav = AppShellSideNavWrapper;
AppShell.Content = AppShellContentWrapper;
AppShell.DevFooter = AppShellDevFooter;

export default AppShell;
